import { makeDoubleArgHook } from "../../utils/makeDoubleArgHook";
import { excludedAssetsURL, getExcludedAssets, } from "../request/getExcludedAssets";
export function excludedAssetsKeyMaker(abstractPortfolioId, concretePortfolioId) {
    return [excludedAssetsURL(abstractPortfolioId, concretePortfolioId)];
}
const useGetExcludedAssets = makeDoubleArgHook(getExcludedAssets, excludedAssetsKeyMaker);
export default useGetExcludedAssets;
//# sourceMappingURL=useGetExcludedAssets.js.map